import { Locale } from '@1inch-community/models';
const rtlLocale = [Locale.ar];
export function isRTL(localeCode) {
    return rtlLocale.includes(localeCode);
}
//# sourceMappingURL=locale.js.map